import { render, staticRenderFns } from "./veTrees.vue?vue&type=template&id=0642af6c&scoped=true&"
import script from "./veTrees.vue?vue&type=script&lang=js&"
export * from "./veTrees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0642af6c",
  null
  
)

export default component.exports